import React, { useState, useEffect } from 'react'
import "../../css/classes/annualView.css"
function AnnualHeadStats({remainingSummary}) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [animatedValues, setAnimatedValues] = useState({
    availableBalance: 0,
    totalIncome: 0,
    totalSpending: 0,
    spendingRate: 0,
    savingRate: 0
  });

  useEffect(() => {
    setIsLoaded(true);
    
    // Animate numbers on load
    const timer = setTimeout(() => {
      setAnimatedValues({
        availableBalance: 9591.75,
        totalIncome: 60600.00,
        totalSpending: 51508.25,
        spendingRate: 66,
        savingRate: 34
      });
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 2
    }).format(amount).replace('₹', '₹ ');
  };
  return (
    <div className="annual-head-stats-dashboard-container">


  <div className="annual-head-stats-dashboard-wrapper">
    {/* Top Cards Row */}
    <div className="annual-head-stats-top-cards-row">
      {/* Available Balance Card */}
      <div className={`annual-head-stats-balance-card ${isLoaded ? 'annual-head-stats-slide-in-left' : ''}`}>
        <div className="annual-head-stats-card-header">
          <i className="fa fa-wallet annual-head-stats-card-icon"></i>
          <span className="annual-head-stats-card-title">Available Balance</span>
        </div>
        <div className="annual-head-stats-balance-amount">
          ₹ <span className="annual-head-stats-animated-number">{animatedValues.availableBalance.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</span>
        </div>
        <div className="annual-head-stats-balance-subtitle">of actual income left to be allocated</div>
      </div>

      {/* Total Income Card */}
      <div className={`annual-head-stats-income-card ${isLoaded ? 'annual-head-stats-slide-in-up' : ''}`}>
        <div className="annual-head-stats-card-header">
          <i className="fa fa-arrow-up annual-head-stats-income-icon"></i>
          <span className="annual-head-stats-card-title">Total Income</span>
        </div>
        <div className="annual-head-stats-income-amount">
          ₹ <span className="annual-head-stats-animated-number">{animatedValues.totalIncome.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</span>
        </div>
        <div className="annual-head-stats-previous-balance">
          <span>Previous Balance</span>
          <span>₹ 500.00</span>
        </div>
      </div>

      {/* Total Spending Card */}
      <div className={`annual-head-stats-spending-card ${isLoaded ? 'annual-head-stats-slide-in-up' : ''}`}>
        <div className="annual-head-stats-card-header">
          <i className="fa fa-shopping-bag annual-head-stats-spending-icon"></i>
          <span className="annual-head-stats-card-title">Total Spending</span>
        </div>
        <div className="annual-head-stats-spending-amount">
          ₹ <span className="annual-head-stats-animated-number">{animatedValues.totalSpending.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</span>
        </div>
        <div className="annual-head-stats-spending-subtitle">(Expenses + Bills + Debts + Savings)</div>
      </div>

      {/* Spending & Saving Rate Card */}
      <div className={`annual-head-stats-rate-card ${isLoaded ? 'annual-head-stats-slide-in-right' : ''}`}>
        <div className="annual-head-stats-rate-header">
          <i className="fa fa-bar-chart annual-head-stats-rate-icon"></i>
          <span className="annual-head-stats-rate-title">Spending & Saving Rate based on</span>
          <span className="annual-head-stats-rate-subtitle">% allocated to Savings</span>
        </div>
        <div className="annual-head-stats-rate-content">
          <div className="annual-head-stats-spending-rate">
            <span className="annual-head-stats-rate-label">You are spending</span>
            <span className="annual-head-stats-spending-percentage">{animatedValues.spendingRate}%</span>
            <span className="annual-head-stats-rate-desc">of your income</span>
          </div>
          <div className="annual-head-stats-saving-rate">
            <span className="annual-head-stats-rate-label">You are saving</span>
            <span className="annual-head-stats-saving-percentage">{animatedValues.savingRate}%</span>
            <span className="annual-head-stats-rate-desc">of your income</span>
          </div>
        </div>
      </div>
    </div>

    {/* Bottom Status Cards */}
    <div className="annual-head-stats-bottom-cards-row">
      <div className={`annual-head-stats-status-card income-under ${isLoaded ? 'annual-head-stats-fade-in-bottom' : ''}`}>
        <div className="annual-head-stats-status-header">
          <i className="fa fa-arrow-down annual-head-stats-status-icon annual-head-stats-down-icon" style={{  display: "flex"}}></i>
          <span className="annual-head-stats-status-title">Income under expected</span>
          <span className="annual-head-stats-status-amount">₹ {(remainingSummary?.Income ?? "").toString()}</span>
        </div>
        <div className="annual-head-stats-status-detail">
          <i className="fa fa-play annual-head-stats-detail-icon"></i>
          <span>Actual Amount Left</span>
          <span>₹ {(remainingSummary?.AmountLeft ?? "").toString()}</span>
        </div>
      </div>

      <div className={`annual-head-stats-status-card annual-head-stats-expenses-budget ${isLoaded ? 'annual-head-stats-fade-in-bottom' : ''}`}>
        <div className="annual-head-stats-status-header">
          <i className="fa fa-arrow-up annual-head-stats-status-icon annual-head-stats-up-icon" style={{  display: "flex"}}></i>
          <span className="annual-head-stats-status-title">Expenses In Budget</span>
          <span className="annual-head-stats-status-amount">₹ {(remainingSummary?.Expenses ?? "").toString()}</span>
        </div>
        <div className="annual-head-stats-status-detail">
          <i className="fa fa-play annual-head-stats-detail-icon"></i>
          <span>Available Balance</span>
          <span>₹ {(remainingSummary?.AmountLeft ?? "").toString()}</span>
        </div>
      </div>

      <div className={`annual-head-stats-status-card annual-head-stats-bills-budget ${isLoaded ? 'annual-head-stats-fade-in-bottom' : ''}`}>
        <div className="annual-head-stats-status-header">
          <i className="fa fa-arrow-up annual-head-stats-status-icon annual-head-stats-up-icon" style={{  display: "flex"}}></i>
          <span className="annual-head-stats-status-title">Bills In Budget</span>
          <span className="annual-head-stats-status-amount">₹ {(remainingSummary?.Bills ?? "").toString()}</span>
        </div>
        <div className="annual-head-stats-status-detail">
          <i className="fa fa-play annual-head-stats-detail-icon"></i>
          <span>Amounts that are not allocated to the next month</span>
          <span>₹ -</span>
        </div>
      </div>

      <div className={`annual-head-stats-status-card annual-head-stats-debts-unpaid ${isLoaded ? 'annual-head-stats-fade-in-bottom' : ''}`}>
        <div className="annual-head-stats-status-header">
          <i className="fa fa-arrow-down annual-head-stats-status-icon annual-head-stats-down-icon" style={{  display: "flex"}}></i>
          <span className="annual-head-stats-status-title">Debts Unpaid</span>
          <span className="annual-head-stats-status-amount">₹ {(remainingSummary?.Debts ?? "").toString()}</span>
        </div>
      </div>

      <div className={`annual-head-stats-status-card annual-head-stats-savings-goal ${isLoaded ? 'annual-head-stats-fade-in-bottom' : ''}`}>
        <div className="annual-head-stats-status-header">
          <i className="fa fa-arrow-down annual-head-stats-status-icon annual-head-stats-down-icon" style={{  display: "flex"}}></i>
          <span className="annual-head-stats-status-title">Savings Under Goal</span>
          <span className="annual-head-stats-status-amount">₹ {(remainingSummary?.Savings ?? "").toString()}</span>
        </div>
      </div>
    </div>
  </div>
</div>
  )
}

export default AnnualHeadStats